module.exports = __webpack_public_path__ + "media/images/ic-lupa-busca-8d5e4463040440ac8db68b24a7d3dd09.svg";